/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".btn-msg[_ngcontent-%COMP%]{background-color:#1f2c5b;color:#fff;border:#1f2c5b}"];
export { styles as styles };
